import React from 'react';
import { withFormsy } from 'formsy-react';
import { NumericFormat } from 'react-number-format';
import { InputAdornment, styled, TextField } from '@mui/material';

import { type FilterItemBaseProps } from '../FilterItemManager';
import Icon from '../../Icon';

const StyledTextField = styled(TextField)(({ theme }) => ({
	'& > .MuiOutlinedInput-root': {
		paddingLeft: 12,
		'& > .MuiOutlinedInput-input': {
			paddingTop: 12,
			paddingBottom: 12
		}
	}
}));

function CurrencyFilterItem(props: FilterItemBaseProps<string | number>) {
	const isDisabled = !!props.defaultValue;

	function handleChange(event) {
		const newStringValue = event.target.value?.replaceAll('.', '').replace(',', '.');
		const newValue = newStringValue && newStringValue !== 0 ? newStringValue : null;
		props.sendChange(props.name, newValue);
	}

	return (
		<NumericFormat
			className={props.className}
			customInput={StyledTextField}
			name={props.name}
			variant="outlined"
			size="small"
			fullWidth
			autoComplete="off"
			placeholder={props.placeholder}
			slotProps={{
				inputLabel: { shrink: true },
				input: {
					startAdornment: (
						<InputAdornment position="start">
							<Icon icon="currency-eur" size={18} />
						</InputAdornment>
					)
				}
			}}
			value={(props.defaultValue || props.value) ?? ''}
			disabled={isDisabled}
			onBlur={handleChange}
			thousandSeparator="."
			decimalSeparator=","
			decimalScale={2}
			fixedDecimalScale
		/>
	);
}

export default React.memo(withFormsy(CurrencyFilterItem));
